<template>
  <div>
    <div>
      <div class="bordered-tabs d-flex justify-content-between">
        <strong class="h5 font-weight-black">
          {{ locale.list }} {{ locale.bankruptDueRights.tabTitle }}
        </strong>
        <div>
          <naj-button
            :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDueRightsConfirmation}`] && isNotCompleted)"
            color="primary"
            @click="addNewHandler"
          >
            <v-icon
              left
              v-text="`mdi-plus`"
            ></v-icon>
            {{ local.common.add }}
          </naj-button>
          <!-- <naj-button
          color="primary"
          @click="importDataHandler"
        >
          {{ locale.importData }}
        </naj-button> -->
        </div>
      </div>
      <div>
        <slot />
      </div>
      <div>
        <v-row>
          <v-col>
            <naj-item-table
              :data-items="bankruptDueRights.list"
              :headers="headers"
              :pagination="pagination"
              :loading="loading"
              :items-per-page="pagination.pageSize"
              :server-items-length="pagination.totalCount"
              :enable-expand="false"
              @update:page="onPageChange"
            >
              <template
                slot="actionEdit"
                slot-scope="{item}"
              >
                <naj-button
                  :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.bankruptDueRightsConfirmation}`] && isNotCompleted)"
                  outlined
                  @click="showUpdateModal(item)"
                >
                  {{ local.common.update }}
                </naj-button>
              </template>
              <template
                slot="actionDelete"
                slot-scope="{item}"
              >
                <naj-button
                  :disabled="isViewMode || (auditConfirmations[`flag_${mainRequestAuditFlag.partnersConfirmation}`] && isNotCompleted)"
                  type="button"
                  color="error"
                  outlined
                  @click="showPopupRemove(item)"
                >
                  {{
                    local.common.remove
                  }}
                </naj-button>
              </template>
            </naj-item-table>
          </v-col>
        </v-row>
      </div>
    </div>
    <naj-modal
      ref="addModal"
      :title="isEditMode? `${local.common.update} ${locale.bankruptDueRights.bankruptDueRight}` : `${local.common.add} ${locale.bankruptDueRights.bankruptDueRight}`"
      :width="1200"
      show-footer-close-button
      @onClose="onCloseModal"
    >
      <v-form ref="addForm">
        <bankrupt-due-rights-form
          :form-model="formModel"
          :loading="loading"
          :request-owner-type-id="requestOwnerTypeId"
          :is-edit-mode="isEditMode"
        ></bankrupt-due-rights-form>
      </v-form>
      <template slot="actions">
        <naj-button
          :loading="loading"
          @click="submit"
        >
          {{ isEditMode? local.common.update :local.common.add }}
        </naj-button>
      </template>
    </naj-modal>
    <naj-confirmation
      :show-modal="showRemovePopup"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="removeBankruptDueRight"
      @cancel="showRemovePopup = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import BankruptDueRightsForm from './bankrupt-due-rights-form.vue';
import { createNamespacedHelpers } from 'vuex';
import { toHijriDate } from '@/helpers/utils';
import { mainRequestAuditFlag, requestStatusEnum } from '@/modules/bankruptcy/helpers/enum';
const { mapActions, mapGetters, mapState } = createNamespacedHelpers('BankruptcyModule');

export default {
  components: { BankruptDueRightsForm },
  props: {
    requestObjectKey: {
      type: String,
      required: true,
      default: '',
    },
    requestOwnerTypeId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      locale: this.local.bankruptcy.requestDetails,
      formModel: {},
      toHijriDate,
      loading: false,
      bankruptDueRights: { list: [] },
      headers: [
        {
          value: 'index',
          text: this.local.bankruptcy.requestDetails.sequence,
        },
        {
          value: 'name',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.name,
        },
        {
          value: 'debtValue',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.debtValue,
        },
        {
          value: 'dueDate',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.dueDate,
          formatter: toHijriDate,
        },
        {
          value: 'identityNumber',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.identityNumber,
        },
        {
          value: 'mobile',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.mobile,
        },
        {
          value: 'email',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.email,
        },
        {
          value: 'guaranteed',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.Guaranteed,
        },
        {
          value: 'guaranteeType',
          text: this.local.bankruptcy.requestDetails.bankruptDueRights.guaranteeType,
        },
        {
          value: 'actionEdit',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },
        {
          value: 'actionDelete',
          class: 'action-item justify-content-center',
          isCustomTemplate: true,
        },

      ],
      pagination: {
        pageSize: 10,
        pageIndex: 0,
        totalCount: 0,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false,
      },
      isEditMode: false,
      mainRequestAuditFlag,
      requestStatusEnum,
      showRemovePopup: false,
      selectedItem: {},
    };
  },
  computed: {
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isNotCompleted',
    ]),
    ...mapState({ auditConfirmations: state => state.auditConfirmations }),
  },
  mounted() {
    this.pagination.pageIndex = 0;
    this.loadData();
  },
  methods: {
    ...mapActions(['submitAddNewBankruptDueRight', 'getBankruptDueRightByRequestObjectKey', 'getBankruptDueRight', 'updateBankruptDueRight', 'deleteBankruptDueRight']),
    addNewHandler() {
      this.isEditMode = false;
      this.$refs.addModal.show();
    },
    importDataHandler() { },
    loadData() {
      this.loading = true;
      this.getBankruptDueRightByRequestObjectKey({
        requestObjectKey: this.requestObjectKey,
        ...this.pagination,
      })
        .then(({ data }) => {
          this.loading = false;
          this.bankruptDueRights = { ...data };
          this.bankruptDueRights.list.forEach((element, index) => {
            element.index = index + 1 + (this.pagination.pageSize * this.pagination.pageIndex);
          });
          this.pagination = {
            pageIndex: data.pageIndex,
            pageSize: data.pageSize,
            totalCount: data.totalCount,
            totalPages: data.totalPages,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
          };
        })
        .finally(() => {
          this.loading = false;
        });

    },
    onPageChange(pageIndex) {
      this.pagination.pageIndex = pageIndex - 1;
      this.loadData();
    },
    showPopupRemove(item) {
      this.showRemovePopup = true;
      this.selectedItem = item;
    },
    removeBankruptDueRight() {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: this.selectedItem.objectKey,
      };
      this.loading = true;
      this.deleteBankruptDueRight(params)
        .then(() => {
          this.loadData();
          this.toaster.success(this.local.bankruptcy.common.removeSuccessfully);
        })
        .finally(() => {
          this.loading = false;
          this.showRemovePopup = false;
        });
    },
    submit() {
      if (this.$refs.addForm)
        this.$refs.addForm.$validator.validateAll().then((valid) => {
          if (valid) {
            this.loading = true;
            this.formModel.requestObjectKey = this.requestObjectKey;
            const method = this.formModel.objectKey ? 'updateBankruptDueRight' : 'submitAddNewBankruptDueRight';
            this[method]({
              requestObjectKey: this.requestObjectKey,
              ...this.formModel,
            })
              .then(() => {
                const message = this.formModel.objectKey ? 'updateSuccessfully' : 'addedSuccessfully';
                this.$refs.addModal.close();
                this.loadData();
                this.toaster.success(this.local.bankruptcy.common[message]);
              })
              .finally(() => { this.loading = false; });
          }
        });
    },
    showUpdateModal(model) {
      const params = {
        requestObjectKey: this.requestObjectKey,
        objectKey: model.objectKey,
      };
      this.loading = true;
      this.getBankruptDueRight(params)
        .then((res) => {
          this.formModel = res.data;
          this.isEditMode = true;
          this.$refs.addModal.show();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetForm() {
      this.$refs.addForm.$validator.reset();
    },
    onCloseModal() {
      for (const key in this.formModel)
        if (Object.hasOwnProperty.call(this.formModel, key))
          this.$set(this.formModel, key, undefined);
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .info-item-box .info-item-details:nth-child(1) {
  background: #faf9f4 0% 0% no-repeat padding-box;
}
</style>
